<template>
  <div class="novidades-portal__grid">
    <div
      v-for="item in items"
      :key="item.idnovidade"
      class="novidades-portal__grid-card"
      @click="onSelect(item.idnovidade)"
    >
      <div>
        <div class="d-flex align-center justify-space-between mb-3">
          <span
            class="novidades-portal__color-badge novidades-portal__color-badge--dot-only"
            :style="badgeStyle(item)"
            :title="scheme(item).name"
            :aria-label="`Cor do release: ${scheme(item).name}`"
          >
            <span
              class="novidades-portal__dot"
              :style="{ backgroundColor: scheme(item).dotColor }"
            />
          </span>
          <span class="novidades-portal__card-dates" style="font-size: 11px;">
            {{ formatDate(item).date }}
          </span>
        </div>

        <div class="d-flex align-start mb-2" style="gap: 12px;">
          <div class="novidades-portal__grid-icon" :style="iconBoxStyle(item)">
            <v-icon x-small color="white">{{ iconClass(item) }}</v-icon>
          </div>
          <h3 class="novidades-portal__card-title" style="font-size: 1rem;">
            {{ item.descricao }}
            <span
              v-if="isRecent(item)"
              class="novidades-portal__latest-badge d-inline-block ml-1"
              style="font-size: 10px; vertical-align: middle;"
            >
              ★ Mais recente
            </span>
          </h3>
        </div>

        <p
          v-if="item.resumo"
          class="novidades-portal__card-resumo line-clamp-3 mb-4"
          style="font-size: 12px;"
        >
          {{ item.resumo }}
        </p>

        <div
          class="novidades-portal__highlight-item mb-0"
          style="font-size: 11px;"
        >
          <div>
            <div class="novidades-portal__highlights-label mb-1">
              {{ improvements(item).length }} itens neste release
            </div>
            <p
              class="mb-0 novidades-portal__highlight-desc"
              style="-webkit-line-clamp: 2;"
            >
              {{
                improvements(item)
                  .map(i => `${i.emoji || ""} ${i.title}`.trim())
                  .join(" · ")
              }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="novidades-portal__card-footer mt-3 pt-3"
        style="margin-top: 12px; padding-top: 12px;"
      >
        <span class="novidades-portal__tag-pill">
          #{{ (item.palavras_chave && item.palavras_chave[0]) || "ecommerce" }}
        </span>
        <span class="novidades-portal__cta">
          Acessar
          <v-icon x-small>fas fa-arrow-right</v-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getColorScheme,
  formatDateTimeBR,
  parseImprovementsFromContent,
  resolveNovidadeIcon
} from "@/utils/novidades";

export default {
  name: "NovidadesGridView",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    recentIds: {
      type: Array,
      default: () => []
    },
    isDark: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scheme(item) {
      return getColorScheme(item.cor, { isDark: this.isDark });
    },
    badgeStyle(item) {
      const s = this.scheme(item);
      return {
        backgroundColor: s.badgeBg,
        color: s.badgeText,
        borderColor: s.badgeBorder
      };
    },
    iconBoxStyle(item) {
      const s = this.scheme(item);
      return {
        background: `linear-gradient(135deg, ${s.gradientFrom}, ${s.gradientTo})`
      };
    },
    iconClass(item) {
      return resolveNovidadeIcon(item.icone).class;
    },
    formatDate(item) {
      return formatDateTimeBR(item.data_publicacao);
    },
    improvements(item) {
      return parseImprovementsFromContent(item.conteudo || "", {
        tags: item.palavras_chave || []
      });
    },
    isRecent(item) {
      return this.recentIds.includes(item.idnovidade);
    },
    onSelect(idnovidade) {
      this.$emit("select", idnovidade);
    }
  }
};
</script>

<style scoped>
.novidades-portal__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
